import state from './moduleTimelineState';
import mutations from './moduleTimelineMutations';
import actions from './moduleTimelineActions';
import getters from './moduleTimelineGetters';

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
